// Over-weight warnings for a pack-desk box tab.
//
// Two ceilings, both on the CONTENTS weight the desk declares:
//   - the box's own limit (dispatch_boxes.max_weight_grams, optional);
//   - the carrier ceiling — the heaviest parcel ANY enabled shipping tier
//     for the warehouse accepts (APC 30 kg per parcel, InPost 30 kg
//     Large). A tier with no cap means "unlimited" and disables the
//     carrier warning rather than inventing a number.
// The tighter breached limit is reported so the packer sees one chip.

export interface WeightWarning {
    kind: "box_max" | "carrier_max";
    limitGrams: number;
    weightGrams: number;
}

export const carrierMaxParcelGrams = (tiers: { maxWeightGrams: number | null }[]): number | null => {
    if (tiers.length === 0) return null;
    let max = 0;
    for (const t of tiers) {
        if (t.maxWeightGrams === null || t.maxWeightGrams === undefined) return null;
        if (t.maxWeightGrams > max) max = t.maxWeightGrams;
    }
    return max > 0 ? max : null;
};

export const boxWeightWarning = ({ contentsGrams, boxMaxGrams, carrierMaxGrams }: {
    contentsGrams: number;
    boxMaxGrams: number | null | undefined;
    carrierMaxGrams: number | null | undefined;
}): WeightWarning | null => {
    const w = Math.max(0, Math.round(contentsGrams));
    const limits: WeightWarning[] = [];
    if (boxMaxGrams != null && boxMaxGrams > 0 && w > boxMaxGrams) limits.push({ kind: "box_max", limitGrams: boxMaxGrams, weightGrams: w });
    if (carrierMaxGrams != null && carrierMaxGrams > 0 && w > carrierMaxGrams) limits.push({ kind: "carrier_max", limitGrams: carrierMaxGrams, weightGrams: w });
    if (limits.length === 0) return null;
    return limits.sort((a, b) => a.limitGrams - b.limitGrams)[0];
};
